module.exports = __webpack_public_path__ + "static/media/U1-T2-3-1b.964b8c24.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/U1-T2-3-1b.mp3
// module id = 574
// module chunks = 0